export default "__VITE_ASSET__C1Xr_6HM__"